import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "assets/svg/CloseIcon";
import React from "react";
import { text } from "stream/consumers";
import theme, { responsiveFontSize } from "themes/Theme";
interface ModalProps {
  open: boolean;
  handleClose: () => void;
  handleLogout: () => void;
}
const UserLogoutDialog: React.FC<ModalProps> = ({
  open,
  handleClose,
  handleLogout,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 4,
          },
        },
      }}
    >
      <DialogContent>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          mb={3}
        >
          <Typography sx={styles.dialogTitle}>Logout</Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon color={theme.palette.primary.main} />
          </IconButton>
        </Stack>
        <Typography>Are you sure you want to logout?</Typography>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"flex-end"}
          gap={2}
          mt={4}
        >
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{ borderRadius: "8px" }}
          >
            <Typography sx={styles.buttonText}>Cancel</Typography>
          </Button>
          <Button
            variant="contained"
            onClick={handleLogout}
            sx={{ borderRadius: "8px" }}
          >
            <Typography sx={styles.buttonText}>Logout</Typography>
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
export default UserLogoutDialog;
const styles = {
  dialogTitle: {
    fontSize: responsiveFontSize(18),
    fontWeight: 400,
    color: theme.palette.primary.main,
  },
  buttonText: {
    textTransform: "capitalize",
    fontSize: responsiveFontSize(16),
    fontWeight: 400,
  },
};
